<!-- src/pages/ScanPage-History.vue -->
<template>
  <div class="detail-page" v-loading="loading"
       element-loading-text="正在加载，请稍等..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-card shadow="hover">
      <!-- 头部返回按钮 -->
      <div slot="header" class="card-header">
          <!-- 基础使用 -->
          <back-button />
        <span style="position: absolute;right: 10px;color: #fff;font-size:16px">设备历史记录</span>
      </div>
      <div style="display: inline-flex;padding-bottom: 15px;border-bottom: solid 1px #f0f0f0;;width: 100%">
        <div>
          <el-divider direction="vertical"></el-divider>
          <span class="vertical-span">日期</span>
        </div>
        <div style="position:absolute;right: 20px">
          <template>
            <el-radio-group v-model="tabPosition" @change="handleChange">
              <el-radio-button label="today">今天</el-radio-button>
              <el-radio-button label="yesterday">昨天</el-radio-button>
              <el-radio-button label="3days">近三天</el-radio-button>
              <el-radio-button label="week">近一周</el-radio-button>
              <el-radio-button label="month">近一月</el-radio-button>
            </el-radio-group>
          </template>
        </div>
      </div>
      <el-row style="padding-top: 15px">
        <el-col class="elCol" :span="24">
          <el-form :model="detailForm" label-width="50px" size="small" label-position="left" >
            <el-form-item label="时间">
              <el-col :span="11">
                <el-date-picker type="date" size="small" placeholder="开始日期" @change="handleDateChange" value-format="yyyy-MM-dd" v-model="beginTime" style="width: 100%;"></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">至</el-col>
              <el-col :span="11">
                <el-date-picker type="date" size="small" placeholder="结束日期" @change="handleDateChange" value-format="yyyy-MM-dd" v-model="endTime" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24" style="font-size: 15px;font-weight: bold;border-bottom: solid 1px #efefef;padding-bottom: 8px">
          <span>当前时间段内累计水量 ：</span><span style="font-size: 22px;border-bottom: solid 2px green">{{valueFlow}}</span><span style="margin-left: 8px">m³</span>
        </el-col>
      </el-row>

      <div style="padding-bottom: 15px;width: 100%">
        <div style="height: 30px;line-height: 30px;">
          <el-divider direction="vertical"></el-divider>
          <span class="vertical-span">历史数据</span>
        </div>
        <div class="unitSign">
          <span style="font-weight: bold;color: red;">单位 :</span>
          <span>瞬时流量 ：(m³/h)</span>
          <span>累计流量 ：(m³)</span>
        </div>
        <div>
          <el-table :data="tableData" stripe style="width: 100%" size="medium" height="500">
            <el-table-column prop="instantFlow" label="瞬时流量" align="center" width="85"></el-table-column>
            <el-table-column label="累计流量" align="center">
              <el-table-column prop="positiveCumulativeFlow" label="正向" align="center" width="90"></el-table-column>
              <el-table-column prop="reverseCumulativeFlow" label="反向" align="center" width="90"></el-table-column>
            </el-table-column>
            <el-table-column prop="dataReadTime" label="上报时间" align="center" width="160"></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 跳转到其他页面示例 -->
<!--      <el-button
          type="primary"
          icon="el-icon-arrow-right"
          @click="jumpToOtherPage"
          style="margin-top: 20px;"
      >
        跳转到首页
      </el-button>-->
    </el-card>
<!--    <HeaderLogo></HeaderLogo>-->
  </div>
</template>
<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import BackButton from '@/components/BackButton';
export default {
  components: { BackButton, HeaderLogo},
  name: 'ScanPageHistory',
  data() {
    return {
      valueFlow:0,
      loading: false,
      tabPosition: 'yesterday',
      beginTime:'',
      endTime:'',
      detailForm: {
        deviceCode: '',
        params:{
          beginTime:'',
          endTime:'',
        }
      },
      tableData: []
    }
  },
  created() {
    // 接收路由参数（两种方式）
    // 方式1：接收路由传参（推荐）
    this.detailForm = {deviceCode: this.$route.query.deviceCode};
    // 设置默认日期范围（昨天）
    this.handleChange('yesterday');
    // 方式2：接收路由动态参数（如 /detail/:userId）
    // this.detailForm.userId = this.$route.params.userId || '';
  },
  methods: {
    onBack() {
      console.log('返回按钮被点击');
    },
    handleChange(tab) {
      this.loading = true;
      this.dataChange(tab);
      this.getQueryList();
    },
    handleDateChange(){
      if (this.validateDateRange()) {
        this.getQueryList();
      }
    },
    /**
     * 查询动态数据
     * 公共方法
     */
    getQueryList(){
      this.tableData = [];
      this.$http.post(process.env.VUE_APP_API_BASE_URL+'system/hongruiHistory/scan_query_history', this.detailForm)
        .then(res => {
          this.loading = false;
          if (res.code === 200 && res.hasOwnProperty("rows")) {
            this.tableData = res.rows;
            if(this.tableData!=null && this.tableData.length>0){
              const minValue = this.tableData[this.tableData.length-1].positiveCumulativeFlow;
              const maxValue = this.tableData[0].positiveCumulativeFlow;
              this.valueFlow = (maxValue - minValue).toFixed(2);
            }
            this.$message({
              message: '恭喜哦，数据加载成功. . . . . .',
              type: 'success',
              center: true
            });
          } else {
            this.$message({
              message: '抱歉哦，数据加载失败. . . . . .',
              type: 'warning',
              center: true
            });
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateDateRange() {
      if (!this.beginTime || !this.endTime) {
        this.$message({
          message: '请选择开始日期和结束日期. . . . . .',
          type: 'error',
          center: true
        });
        return false;
      }

      const startDate = new Date(this.beginTime);
      const endDate = new Date(this.endTime);

      // 检查结束日期是否大于开始日期
      if (endDate < startDate) {
        this.$message({
          message: '结束日期必须大于开始日期. . . . . .',
          type: 'error',
          center: true
        });
        return false;
      }

      // 计算天数差
      const timeDiff = endDate.getTime() - startDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

      // 检查是否超过31天
      if (daysDiff > 31) {
        this.$message({
          message: '日期范围不能超过31天. . . . . .',
          type: 'error',
          center: true
        });
        return false;
      }
      return true;
    },

    /**
     * 跳转到其他页面（示例）
     */
    jumpToOtherPage() {
      // 方式1：push - 新增历史记录（支持返回）
      this.$router.push({ path: '/' });

      // 方式2：replace - 替换当前历史记录（不支持返回）
      // this.$router.replace({ path: '/' });

      // 方式3：带参数跳转
      // this.$router.push({
      //   path: '/scan',
      //   query: { userId: '1002', source: 'detail_page' }
      // });
    },
    dataChange(tab) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const todayStr = `${year}-${month}-${day}`;

      switch(tab) {
        case 'today':
          this.beginTime = todayStr;
          this.endTime = todayStr;
          break;
        case 'yesterday':
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          const yesterdayStr = `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1).padStart(2, '0')}-${String(yesterday.getDate()).padStart(2, '0')}`;
          this.beginTime = yesterdayStr;
          this.endTime = yesterdayStr;
          break;
        case '3days':
          const threeDaysAgo = new Date(today);
          threeDaysAgo.setDate(today.getDate() - 2);
          const threeDaysAgoStr = `${threeDaysAgo.getFullYear()}-${String(threeDaysAgo.getMonth() + 1).padStart(2, '0')}-${String(threeDaysAgo.getDate()).padStart(2, '0')}`;
          this.beginTime = threeDaysAgoStr;
          this.endTime = todayStr;
          break;
        case 'week':
          const weekAgo = new Date(today);
          weekAgo.setDate(today.getDate() - 6);
          const weekAgoStr = `${weekAgo.getFullYear()}-${String(weekAgo.getMonth() + 1).padStart(2, '0')}-${String(weekAgo.getDate()).padStart(2, '0')}`;
          this.beginTime = weekAgoStr;
          this.endTime = todayStr;
          break;
        case 'month':
          const monthAgo = new Date(today);
          monthAgo.setMonth(today.getMonth() - 1);
          const monthAgoStr = `${monthAgo.getFullYear()}-${String(monthAgo.getMonth() + 1).padStart(2, '0')}-${String(monthAgo.getDate()).padStart(2, '0')}`;
          this.beginTime = monthAgoStr;
          this.endTime = todayStr;
          break;
        default:
          this.beginTime = '';
          this.endTime = '';
      }
      this.detailForm = {deviceCode: this.detailForm.deviceCode,params: {beginTime: this.beginTime+" "+"00:00:00",endTime: this.endTime+" "+"23:59:59"}}
    }
  }
}
</script>

<style scoped>
.unitSign{
  background: #e2caff;
  height: 40px;
  line-height: 40px;
  border-top: solid 2px #efefef;
  border-bottom: solid 2px #efefef;
  font-size: 14px;
}
.unitSign span{
  padding: 10px 10px 3px 10px;
  font-weight: bold;
}
.unitSign span:nth-child(2){
  border-bottom: solid 1px red;
}
.unitSign span:nth-child(3){
  margin-left: 5%;
  border-bottom: solid 1px red;
}
::v-deep .el-table th.el-table__cell>.cell{
  font-size: 15px;
  color: #666667;
  font-weight: 400;
}
::v-deep .el-button--text{
  color: #fff;
  padding-left: 10px;
}
::v-deep .el-button--medium{
  font-size: 16px;
}
.detail-page {
  /*padding: 20px;*/
  max-width: 750px;
  margin: 0 auto;
  background-color: #f5f5f5;
  min-height: 100vh;
}
::v-deep .el-card__header{
  height: 55px;
  line-height: 55px;
  padding: 0;
  background-color: #409eff;;
}
::v-deep .el-divider--vertical{
  width: 4px;
  background: #409eff;
}
::v-deep .vertical-span{
  font-size: 14px;
}
::v-deep .el-radio-button__inner{
  padding: 4px 8px;
}
::v-deep .el-col-2{
  text-align: center;
}

::v-deep .elCol .el-input__inner{
  border: none;
  border-bottom: solid 1px #efefef;
}

.card-header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
/* 在 style scoped 部分添加 */
::v-deep .el-table {
  /* 隐藏横向滚动条，但仍可滚动 */
  overflow-x: hidden;
}

::v-deep .el-table__body-wrapper {
  /* 隐藏滚动条样式 */
  -ms-overflow-style: none;  /* IE 和 Edge */
  scrollbar-width: none;     /* Firefox */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  /* Chrome、Safari、Opera */
  display: none;
}

</style>